import { Button } from 'primereact/button'
import { useState } from 'react'
import ServiceWindow from '../../models/ServiceWindow'
import t from '../../tools/t'
import { useServiceWindowContext } from '../contexts/ServiceWindowContext'
import { useUserContext } from '../contexts/UserContext'
import { PermissionSuffix } from '../../_generated/api/user-management'
import DialogContainer from '../common/pure/DialogContainer'
import { Row } from '../common/pure/FlexContainer'
import { pi } from '../common/pure/PrimeIcon'
import { Message } from 'primereact/message'

export default function ServiceWindowCompleteDialog({
    window,
    onHide,
}: {
    window: ServiceWindow
    onHide: () => void
}) {
    const { complete, saving } = useServiceWindowContext()
    const { can } = useUserContext()
    const [failed, setFailed] = useState(false)
    const submit = async () => {
        if (await complete(window)) onHide()
        else setFailed(true)
    }
    return (
        <DialogContainer
            size="medium"
            header={t('service_window_complete')}
            visible
            modal
            onHide={() => {
                if (!saving) onHide()
            }}
            closable={!saving}
            footer={
                <Row gap={0.5} arrangement="end">
                    <Button
                        label={t('common_cancel')}
                        outlined
                        disabled={saving}
                        onClick={onHide}
                    />
                    <Button
                        label={t('service_window_serviced')}
                        icon={pi('check')}
                        loading={saving}
                        disabled={!window.canComplete || !can(PermissionSuffix.StructureWrite)}
                        onClick={submit}
                    />
                </Row>
            }
        >
            <p>
                {t(
                    'service_window_complete_confirm',
                    window.name,
                    String(window.data.boltConnections.length)
                )}
            </p>
            {failed && <Message severity="error" text={t('service_window_write_failed')} />}
        </DialogContainer>
    )
}
